import { render, staticRenderFns } from "./ValuesHistory.vue?vue&type=template&id=3d57287e&scoped=true&"
import script from "./ValuesHistory.vue?vue&type=script&lang=ts&"
export * from "./ValuesHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57287e",
  null
  
)

export default component.exports